import * as React from 'react'
import { Navigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { authState, resetAuth } from '../store/authState.ts'
import { resetData } from '../store/dataState.ts'

interface Props {
    children: React.ReactNode
}

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
    // Subscribe to the token so route decisions re-evaluate on logout / expiry
    const { token } = useSnapshot(authState)

    // Clear stores when unauthenticated — as a side effect, not during render
    React.useEffect(() => {
        if (!token) {
            resetAuth()
            resetData()
        }
    }, [token])

    if (!token) {
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}
